
import api from '../../plugins/api';

const getPower = (params) => {
  return api.get('/api/shop/getPower', params);
};

export default getPower;
